import React from 'react'
import styles from '../../table.module.scss';


const EditButton = ({className, style, onClick, ...other}) => {
    return <button className={`${styles.edit_button} ${className ? className : ""}`} style={style} {...other} onClick={onClick}></button>
} 

export default EditButton;